module.exports = __webpack_public_path__ + "img/about-icon5.b7120540.png";